import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { Box, CircularProgress, Typography } from '@mui/material';
import { useAuth } from '../contexts/AuthContext';
import { developerPath } from '../utils/developerHost';

/** Partner-only gate for the developer portal. */
const DeveloperPrivateRoute = ({ children }) => {
  const { isTokenExpired, loading } = useAuth();
  const location = useLocation();
  const partnerToken = localStorage.getItem('partnerToken');
  const partner = partnerToken ? JSON.parse(localStorage.getItem('partner') || '{}') : null;

  if (loading) {
    return (
      <Box
        display="flex"
        flexDirection="column"
        justifyContent="center"
        alignItems="center"
        height="100vh"
        gap={2}
      >
        <CircularProgress size={40} />
        <Typography variant="body2" color="text.secondary">
          Authenticating...
        </Typography>
      </Box>
    );
  }

  if (!partner || !partnerToken || isTokenExpired(partnerToken)) {
    localStorage.removeItem('partnerToken');
    localStorage.removeItem('partner');
    return <Navigate to={developerPath('login')} state={{ from: location }} replace />;
  }

  return children;
};

export default DeveloperPrivateRoute;
